import React, { useState } from "react";
import * as moment from "moment";
import states from "../../../utils/statesAndLocalGov.json"
import { api, API_ROUTES } from '../../../utils/http'
import { validateAge, validateEmail } from '../../../utils/validateDataEntry';
import { getRequiredFieldsMessage } from '../../../utils/formValidation';

import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Grid,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch } from "react-redux";
import { addPersonalInfo } from "../../../redux/reducers/features/applicant-data/personal-info-slice";

const ng_universities = require("ng_universities");

export default function PersonalInfo({ onSubmit }) {
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState(""),
    [lastName, setLastName] = React.useState(""),
    [middleName, setMiddleName] = React.useState(""),
    [phone, setPhone] = React.useState(""),
    [nationality, setNationality] = React.useState(""),
    [state, setState] = React.useState(""),
    [lg, setLg] = React.useState([]),
    [city, setCity] = React.useState(""),
    [email, setEmail] = React.useState(""),
    [password, setPassword] = React.useState(""),
    [confirmPassword, setConfirmPassword] = React.useState(""),
    [guardianName, setGuardianName] = React.useState(""),
    [guardianAddress, setGuardianAddress] = React.useState(""),
    [guardianPhone, setGuardianPhone] = React.useState(""),
    [allStates, setAllStates] = React.useState([]),
    [guardianRelationship, setGuardianRelationship] = React.useState(""),
    [dob, setDob] = React.useState(null),
    [showPassword, setShowPassword] = React.useState(false),
    [showConfirmPassword, setShowConfirmPassword] = React.useState(false),
    [gender, setGender] = React.useState(""),
    [isSubmitting, setIsSubmitting] = React.useState(false),
    [errors, setErrors] = React.useState({});
  const [selectedState, setSelectedState] = useState("");
  const [lgas, setLgas] = useState([]);

  const handlePasswordIconClick = () => setShowPassword(!showPassword);
  const handleConfirmPasswordIconClick = () =>
    setShowConfirmPassword(!showConfirmPassword);


  const validateDOB = (event) => {
    if (validateAge(event)) {
      setDob(event)
    } else {
      toast.error("Student age must not be less than 14 years")
    }


  }


  const handleOnProceed = async () => {
    setIsSubmitting(true);

    const requiredFields = [
      { label: "First Name", value: firstName },
      { label: "Last Name", value: lastName },
      { label: "Phone Number", value: phone },
      { label: "Date of Birth", value: dob },
      { label: "Email", value: email },
      { label: "Password", value: password },
      { label: "Confirm Password", value: confirmPassword },
      { label: "Guardian Name", value: guardianName },
      { label: "Guardian Phone Number", value: guardianPhone },
      { label: "Guardian Address", value: guardianAddress },
      { label: "Guardian Relationship", value: guardianRelationship },
      { label: "Nationality", value: nationality },
      { label: "State of Origin", value: selectedState },
      { label: "Local Government Area", value: lg },
      { label: "City", value: city },
      { label: "Gender", value: gender },
    ];

    const requiredMessage = getRequiredFieldsMessage(requiredFields);

    if (requiredMessage) {
      toast.error(requiredMessage);
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Enter a valid email address.");
      return;
    }

    let data = {
      first_name: firstName,
      last_name: lastName,
      middle_name: middleName,
      phone: phone,
      nationality: nationality,
      entry_mode: 'JAMB Entry',
      state: selectedState,
      lg: lg,
      city: city,
      email: email,
      dob: dob,
      gender: gender,
      password: password,
      guardian: {
        name: guardianName,
        phone: guardianPhone,
        address: guardianAddress,
        relationship: guardianRelationship,
      },
    };

    dispatch(
      addPersonalInfo({
        first_name: data.first_name,
        last_name: data.last_name,
        middle_name: data.middle_name,
        phone: data.phone,
        nationality: data.nationality,
        state: data.state,
        lg: data.lg,
        city: data.city,
        email: data.email,
        gender: data.gender,
        dob: moment(dob).format("YYYY-MM-DD"),
        guardian_phone: data.guardian.phone,
        guardian_name: data.guardian.name,
        guardian_relationship: data.guardian.relationship,
        guardian_address: data.guardian.address,
        password: data.password
      })
    );
    onSubmit(data);
  };
  const handleStateSelect = (event) => {
    const selectedState = event.target.value;
    setSelectedState(selectedState);

    const stateData = allStates.find((state) => state.state === selectedState);

    // Update the LGAs based on the selected state
    setLgas(stateData ? stateData.lgas : []);
  };
  React.useEffect(() => {
    setAllStates(states);
  }, []);

  React.useEffect(() => {


    (async function () {
      try {

        const res = await api.get(API_ROUTES.department)
        const departments = res?.data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();

    // Faculty removed
    // (async function () {
    //   try {
    //     const url = baseUrl + '/api/faculty'
    //     const res = await api.get(url)
    //     const faculties = res.data
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // })();

  }, []);

  React.useEffect(() => {
    const nextErrors = {};

    const requiredFields = [
      ["first_name", firstName, "First name"],
      ["last_name", lastName, "Last name"],
      ["phone", phone, "Phone number"],
      ["nationality", nationality, "Nationality"],
      ["state", selectedState, "State of origin"],
      ["lg", lg, "Local government area"],
      ["city", city, "City"],
      ["email", email, "Email"],
      ["dob", dob, "Date of birth"],
      ["gender", gender, "Gender"],
      ["password", password, "Password"],
      ["confirm_password", confirmPassword, "Confirm password"],
      ["guardian_name", guardianName, "Guardian name"],
      ["guardian_phone", guardianPhone, "Guardian phone number"],
      ["guardian_address", guardianAddress, "Guardian address"],
      ["guardian_relationship", guardianRelationship, "Guardian relationship"],
    ];

    requiredFields.forEach(([key, value, label]) => {
      if (!value || (typeof value === "string" && !value.trim())) {
        nextErrors[key] = `${label} is required`;
      }
    });

    if (email && !validateEmail(email)) {
      nextErrors.email = "Enter a valid email address";
    }

    if (password && confirmPassword && password !== confirmPassword) {
      nextErrors.confirm_password = "Passwords do not match";
    }

    setErrors(nextErrors);
  }, [
    city,
    confirmPassword,
    dob,
    email,
    firstName,
    gender,
    guardianAddress,
    guardianName,
    guardianPhone,
    guardianRelationship,
    lastName,
    lg,
    nationality,
    password,
    phone,
    selectedState,
  ]);

  return (
    <Card sx={{ p: { xs: 0, lg: 3 }, mt: { xs: 1.8, lg: 3 } }}>
      <CardContent>
        <Typography
          variant="h6"
          component="h6"
          color="#00356B"
          sx={{
            fontStyle: 'italic',
            margin: '1rem 0',
            fontSize: '25px',
            lineHeight: '30px',
            fontWeight: '500',
            width: '100%'
          }}
        >
          Personal Details
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="First Name" required
                variant="outlined"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                error={!!(isSubmitting && errors && errors.first_name)}
                helperText={isSubmitting && errors && errors.first_name}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Last Name" required
                variant="outlined"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                error={!!(isSubmitting && errors && errors.last_name)}
                helperText={isSubmitting && errors && errors.last_name}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Middle Name (Optional)"
                variant="outlined"
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Phone Number" required
                variant="outlined"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                error={!!(isSubmitting && errors && errors.phone)}
                helperText={isSubmitting && errors && errors.phone}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl
              sx={{ mt: 2, minWith: "100%" }}
              variant="outlined"
              fullWidth
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    format="DD-MM-YYYY"
                    label="Select Date of Birth"
                    value={dob}
                    onChange={(newValue) => validateDOB(newValue)}
                    slotProps={{ textField: { fullWidth: true, required: true } }}
                    error={!!(isSubmitting && errors && errors.dob)}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Email" required
                variant="outlined"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={!!(isSubmitting && errors && errors.email)}
                helperText={isSubmitting && errors && errors.email}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-password" required>
                Password
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handlePasswordIconClick}
                      onMouseDown={handlePasswordIconClick}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-confirm-password" required>
                Confirm Password
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-confirm-password"
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleConfirmPasswordIconClick}
                      onMouseDown={handleConfirmPasswordIconClick}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="Confirm Password"
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Guardian name" required
                variant="outlined"
                placeholder="Enter Guardian Name"
                value={guardianName}
                onChange={(e) => setGuardianName(e.target.value)}
                error={!!(isSubmitting && errors && errors.guardian_name)}
                helperText={isSubmitting && errors && errors.guardian_name}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Guardian Phone Number" required
                variant="outlined"
                placeholder="Enter Guardian Phone Number"
                value={guardianPhone}
                onChange={(e) => setGuardianPhone(e.target.value)}
                error={!!(isSubmitting && errors && errors.guardian_phone)}
                helperText={isSubmitting && errors && errors.guardian_phone}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Guardian Address" required
                variant="outlined"
                placeholder="Enter Guardian Address"
                value={guardianAddress}
                onChange={(e) => setGuardianAddress(e.target.value)}
                error={!!(isSubmitting && errors && errors.guardian_address)}
                helperText={isSubmitting && errors && errors.guardian_address}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Guardian Relationship" required
                placeholder="brother, father, uncle, aunt"
                variant="outlined"
                value={guardianRelationship}
                onChange={(e) => setGuardianRelationship(e.target.value)}
                error={
                  !!(isSubmitting && errors && errors.guardian_relationship)
                }
                helperText={
                  isSubmitting && errors && errors.guardian_relationship
                }
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="Nationality" required
                placeholder="e.g Nigerian"
                variant="outlined"
                value={nationality}
                onChange={(e) => setNationality(e.target.value)}
                error={!!(isSubmitting && errors && errors.nationality)}
                helperText={isSubmitting && errors && errors.nationality}
              />
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} lg={6}>
            <FormControl sx={{ mt: 3 }} variant="outlined" fullWidth>
              <TextField
                label="State of Origin"
                placeholder="Anambra, Niger, Sokoto, Lagos"
                variant="outlined"
                value={state}
                onChange={(e) => setState(e.target.value)}
                error={!!(isSubmitting && errors && errors.state)}
                helperText={isSubmitting && errors && errors.state}
              />
            </FormControl>
          </Grid> */}

          <Grid item size={{ xs: 12, md: 6 }} spacing={2} mt={3}>
            <FormControl sx={{ minWidth: "100%" }}>
              <InputLabel required>Select State of Origin</InputLabel>
              <Select
                onChange={handleStateSelect}
                fullWidth
                label="Select State of Origin"
                value={selectedState}
              >
                {allStates?.map((stateData, index) => (
                  <MenuItem value={stateData.state} key={index}>
                    {stateData.state}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ marginTop: "16px", minWidth: "100%" }}>
              <InputLabel required>Select LGA</InputLabel>
              <Select
                value={lg}
                onChange={(e) => setLg(e.target.value)}
                fullWidth
                label="Select LGA"
              >
                {/* <MenuItem value="" defaultChecked>"Select Local Govt"</MenuItem> */}
                {lgas?.map((lga, index) => (
                  <MenuItem value={lga} key={index}>
                    {lga}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl sx={{ marginTop: "16px", minWidth: "100%" }}>
              <TextField
                label="City" required
                placeholder="Onitsa, Kano, Suleja, Sabon Gida"
                variant="outlined"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                error={!!(isSubmitting && errors && errors.city)}
                helperText={isSubmitting && errors && errors.city}
              />
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Grid container spacing={2} className="px-2 w-100" >
          <Grid size={{ xs: 6, md: 6 }} >
            <FormControl >
              <FormLabel required>Gender</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={gender}
                defaultValue={"male"}
                onChange={(e) => setGender(e.target.value)}
              >
                <FormControlLabel
                  value="male"
                  control={<Radio />}
                  label="Male"
                />
                <FormControlLabel
                  value="female"
                  control={<Radio />}
                  label="Female"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item size={{ xs: 6, md: 6 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleOnProceed}
              sx={{
                py: 1.5,
                mt: 2,
                textTransform: "uppercase",
                borderRadius: 2,
                color: "#fff",
              }}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}
